// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_CriarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /implantacao/criar — abre a jornada de uma franquia (Full). Chamado NS 2026-0079. */
import { registerContract } from './validate'

export interface Implantacao_CriarInput {
franquia_id?: number
lead_ref?: string
}

registerContract('Implantacao_CriarInput', {
  franquia_id: { type: 'number',  required: false },
  lead_ref:    { type: 'string',  required: false },
})
